export const definesize = { // eslint-disable-line
  name: 'definesize',
  inserted: (el, binding) => {
    if (!binding.value) return

    changeSize(el)

    window.addEventListener('resize', () => {
      changeSize(el)
    })
  }
}

const changeSize = (el) => {
  el.style.height = `${(el.offsetWidth / 1.78)}px`
}
